<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-customer"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Bill of Material' : 'Tambah Bill of Material' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputSelect v-model="itemId" id="category-select" label="Item" :options="optionItems"
          placeholder="Pilih item" :valid="validation.item_id.valid"
          :error-message="validation.item_id.message" />
        <InputText type="number" v-model="qty" id="item-price" label="Qty" input_class="w-full"
          :valid="validation.qty.valid" :error-message="validation.qty.message" />
        <!-- <InputRupiah v-model="itemPurchasePrice" id="item-purchase-price" label="Harga" input_class="w-full"
          :valid="validation.purchase_price.valid" :error-message="validation.purchase_price.message" /> -->
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitBillOfMaterialDetail" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions, mapGetters } from 'vuex';
import InputSelect from '../form/InputSelect.vue';
import InputText from '../form/InputText.vue';

export default {
  name: "ModalBillOfMaterialDetail",
  props: {
    billOfMaterialDetail: {
      type: Object,
      default: null,
    },
    parentItemId: {
      type: Number,
      required: true,
    },
  },
  components: {
    SubmitButton, InputText, InputSelect
  },
  data() {
    return {
      showModal: true,
      itemId: this.billOfMaterialDetail ? this.billOfMaterialDetail.item_id : null,
      qty: this.billOfMaterialDetail ? this.billOfMaterialDetail.qty : 0,
      optionItems: [],
      optionUnits: [],
      isEdit: !!this.billOfMaterialDetail,
      validation: {
        item_id: {
          valid: true,
          message: ''
        },
        qty: {
          valid: true,
          message: ''
        },
      },
      field: ['item_id', 'qty'],
    }
  },
  computed: {
    ...mapGetters('items', ['allItems']),
    ...mapGetters('units', ['allUnits'])
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('items/fetchItems', { limit: 1000 }),
      this.$store.dispatch('units/fetchUnits', { limit: 1000, status: 'active' }),
    ]);
    this.optionItems = this.allItems.filter(item => item.id != this.parentItemId).map(item => ({ label: item.name, value: item.id }))
    this.optionUnits = this.allUnits.map(unit => ({ label: unit.name, value: unit.id }));
  },
  watch: {
    billOfMaterialDetail(newVal) {
      if (newVal) {
        this.itemId = newVal.item_id;
        this.qty = newVal.qty;
        this.isEdit = true;
      } else {
        this.itemId = null;
        this.qty = 0;
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('bill_of_material_details', ['createBillOfMaterialDetail', 'updateBillOfMaterialDetail']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitBillOfMaterialDetail() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan resep?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postBillOfMaterialDetail();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan resep', life: 3000 });
        }
      });
    },
    async postBillOfMaterialDetail() {
      try {
        const billOfMaterialDetailData = {
          parent_item_id: this.parentItemId,
          item_id: this.itemId,
          qty: this.qty,
        };

        if (this.isEdit && this.billOfMaterialDetail) {
          billOfMaterialDetailData.id = this.billOfMaterialDetail.id;
          await this.updateBillOfMaterialDetail(billOfMaterialDetailData);
        }
        else {
          await this.createBillOfMaterialDetail(billOfMaterialDetailData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Resep berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>